// extracted by mini-css-extract-plugin
module.exports = {"calendar":"UFOPeriodMonthFieldDialog_calendar__3CgCR","visible":"UFOPeriodMonthFieldDialog_visible__2Iph5"};